import { approveOrder, deleteOrder, getCreate, getOrders, rejectOrder, saveOrder, downloadPdf } from "@/api/Purchases/orders";
import { useQuery, useMutation, useQueryClient } from "react-query";
import _ from "lodash";

export const key = "purchase_orders";

export function useOrderPaginate(params) {
	return useQuery([key, { ...params }], () => getOrders(params));
}

export function useOrderCreate(params) {
	return useQuery([key, { ...params }], () => getCreate(params));
}

export function useOrderSave(base, params) {
	const queryClient = useQueryClient();

	return useMutation(saveOrder, {
		onSuccess: (response) => {
			const list = _.omit(response, "order");
			const detail = response.order;

			queryClient.setQueryData([key, { ...base }], list);
			const query_data = { ...queryClient.getQueryData([key, { ...params }]) };

			if (detail) {
				query_data.order = detail;
				if (!params.code) {
					query_data.code = Number(detail.code_oc) + 1;
				}

				queryClient.setQueryData([key, { ...params }], query_data);
			}
		},
	});
}

export function useOrderApprove(base, params) {
	const queryClient = useQueryClient();

	return useMutation(approveOrder, {
		onSuccess: (response) => {
			const list = _.omit(response, "order");
			const detail = response.order;

			queryClient.setQueryData([key, { ...base }], list);
			const query_data = { ...queryClient.getQueryData([key, { ...params }]) };

			if (detail) {
				query_data.order = detail;
				queryClient.setQueryData([key, { ...params }], query_data);
			}
		},
	});
}

export function useOrderReject(base, params) {
	const queryClient = useQueryClient();

	return useMutation(rejectOrder, {
		onSuccess: (response) => {
			const list = _.omit(response, "order");
			const detail = response.order;

			queryClient.setQueryData([key, { ...base }], list);
			const query_data = { ...queryClient.getQueryData([key, { ...params }]) };

			if (detail) {
				query_data.order = detail;
				queryClient.setQueryData([key, { ...params }], query_data);
			}
		},
	});
}

export function useOrderDelete(base, params) {
	const queryClient = useQueryClient();

	return useMutation(deleteOrder, {
		onSuccess: (response) => {
			const list = _.omit(response, "order");
			const detail = response.order;

			queryClient.setQueryData([key, { ...base }], list);
			const query_data = { ...queryClient.getQueryData([key, { ...params }]) };

			if (detail) {
				query_data.order = detail;
				queryClient.setQueryData([key, { ...params }], query_data);
			}
		},
	});
}

export function useDownloadPdf(code) {
	return useMutation(downloadPdf, {
		onSuccess: (response) => {
			const href = URL.createObjectURL(response);

			const link = document.createElement("a");
			link.href = href;
			link.setAttribute("download", `OC_${code}.pdf`);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		},
	});
}
